import { render } from "./ModuleTabbar.vue?vue&type=template&id=1c7f4810&scoped=true"
import script from "./ModuleTabbar.vue?vue&type=script&lang=js"
export * from "./ModuleTabbar.vue?vue&type=script&lang=js"

import "./ModuleTabbar.vue?vue&type=style&index=0&id=1c7f4810&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c7f4810"]])

export default __exports__